





































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import dxTextBox from 'devextreme/ui/text_box';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxRequiredRule, DxValidator } from 'devextreme-vue/validator';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';

@Component({
  components: {
    DxPopup,
    DxRequiredRule,
    DxTextBox,
    DxToolbarItem,
    DxValidator
  }
})
export default class EditInvoiceNumber extends Vue {
  private readonly title: string = 'Change Invoice Number';
  private originalValue: string = '';
  private showDialog: boolean = false;
  private textBox: dxTextBox | undefined;

  public dialogResult: boolean | null = null;
  public lineItem: InvoiceLookupLineItemDto | null = null;
  public value: string = '';
  public valueChanged: boolean = false;

  private get okButtonOptions() {
    return {
      text: 'OK',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.ok
    };
  }

  private get cancelButtonOptions() {
    return {
      text: 'Cancel',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.cancel
    };
  }

  public show() {
    this.showDialog = true;
  }

  private ok() {
    if (this.isValid()) {
      this.close(true);
    }
  }

  private isValid() {
    if (this.textBox == null) {
      return true;
    }

    return this.textBox.option('isValid') as boolean;
  }

  private cancel() {
    this.close(false);
  }

  private close(dialogResult: boolean) {
    this.dialogResult = dialogResult;
    this.showDialog = false;
  }

  private onShowing() {
    this.dialogResult = null;
    this.originalValue = this.value;
  }

  @Emit('hiding')
  private onHiding() {
    this.valueChanged = this.value !== this.originalValue;
    return this.dialogResult;
  }

  private onTextBoxInitialized(e: any) {
    this.textBox = e.component;
  }
}
